<nw-icon class="nw-bank-logo__icon" [icon]="icon"></nw-icon>
